import React from "react";
import { GoCalendar, GoLaw, GoPackage, GoDatabase, GoCreditCard, GoGraph } from "react-icons/go";

function formatCompact(num) {
  if (!num || num === 0) return "R$ 0";
  const absNum = Math.abs(num);
  if (absNum >= 1000000) return `R$ ${(num / 1000000).toFixed(1)}M`;
  if (absNum >= 1000) return `R$ ${(num / 1000).toFixed(1)}K`;
  return `R$ ${num.toFixed(0)}`;
}

export default function ProductTaxKPIs({ taxTotals }) {
  const kpiData = [
    { label: "ICMS", value: formatCompact(taxTotals.icms), icon: GoCalendar, color: "#3b82f6" },
    { label: "PIS/COFINS", value: formatCompact(taxTotals.pisCofins), icon: GoLaw, color: "#10b981" },
    { label: "IPI", value: formatCompact(taxTotals.ipi), icon: GoPackage, color: "#f59e0b" },
    { label: "IBS", value: formatCompact(taxTotals.ibs), icon: GoDatabase, color: "#8b5cf6" },
    { label: "CBS", value: formatCompact(taxTotals.cbs), icon: GoCreditCard, color: "#06b6d4" },
    { label: "IS", value: formatCompact(taxTotals.is), icon: GoGraph, color: "#ec4899" },
  ];

  return (
    <div className="tax-kpi-cards">
      {kpiData.map((kpi, i) => {
        const Icon = kpi.icon;
        return (
          <div key={i} className="tax-kpi-card">
            <div className="card-content">
              <div className="thumb" style={{ color: kpi.color, opacity: 0.65 }}>
                <Icon />
              </div>
              <div className="text">
                <p>{kpi.value}</p>
                <p>{kpi.label}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
